import React, { useEffect, useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { reportsAPI } from '../services/api';

const tabs = [
  { key: 'rent-roll', title: 'Rent Roll' },
  { key: 'delinquency-aging', title: 'Delinquency Aging' },
  { key: 'occupancy', title: 'Occupancy' },
  { key: 'maintenance-aging', title: 'Maintenance Aging' },
  { key: 'income-summary', title: 'Income Summary' },
];

const Reports = () => {
  const [active, setActive] = useState('rent-roll');
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = async (which) => {
    setLoading(true);
    setError('');
    try {
      const data = await reportsAPI.get(which);
      setRows(Array.isArray(data) ? data : []);
    } catch (e) {
      setError(e.message || 'Failed to load report');
    } finally {
      setLoading(false);
    }
  };

  useEffect(()=>{ load(active); }, [active]);

  const exportCsv = async () => {
    try {
      const blob = await reportsAPI.csv(active);
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${active}.csv`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch {}
  };

  const headers = rows && rows[0] ? Object.keys(rows[0]) : [];

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Reports</h1>
          <p className="text-gray-600 mt-1">View standard reports and export CSV</p>
        </div>
      </div>

      <div className="border-b border-gray-200">
        <nav className="-mb-px flex space-x-8">
          {tabs.map(t => (
            <button key={t.key} onClick={()=> setActive(t.key)} className={`py-2 px-1 border-b-2 font-medium text-sm ${active===t.key ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`}>{t.title}</button>
          ))}
        </nav>
      </div>

      <Card>
        <CardHeader>
          <div className="flex items-center justify-between">
            <CardTitle>{tabs.find(t => t.key===active)?.title}</CardTitle>
            <Button onClick={exportCsv}>Export CSV</Button>
          </div>
        </CardHeader>
        <CardContent>
          {loading && <div className="text-sm text-gray-500">Loading...</div>}
          {error && <div className="text-sm text-red-600">{error}</div>}
          {!loading && !error && (
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead>
                  <tr>
                    {headers.map(h => <th key={h} className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">{h.replace('_',' ')}</th>)}
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {rows.map((r, idx) => (
                    <tr key={idx}>
                      {headers.map(h => <td key={h} className="px-6 py-4 text-sm">{String(r[h] ?? '')}</td>)}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default Reports;